import * as VonqService from './service/VonqConnectionService';

const VONQ_SESSION_KEY = "vonq_sesssion_key";

/**
 * Attempts to retrieve the session from local session storage.
 * If not available, requests token from Jobtoolz endpoint.
 * Once available stores in the session storage, returning token.
 * @returns String 
 */
export async function getSession() {
    let sessionToken = sessionStorage.getItem(VONQ_SESSION_KEY);
    
    if (sessionToken) {
        sessionToken = JSON.parse(sessionToken);
    } else {
        const {data} = await VonqService.getToken();
        sessionToken = data;
        sessionStorage.setItem(VONQ_SESSION_KEY, JSON.stringify(data));
    }
    
    return sessionToken.token;
}


/**
 * Register events
 * Custom event vonq:onChangeJWTTokenEvent : used to trigger local storage key update.
 */
function _bindings() {
    window.addEventListener("vonq:onChangeJWTTokenEvent",
    (e) => {
       const temp = JSON.parse(sessionStorage.getItem(VONQ_SESSION_KEY)) || {token:""};
       temp.token = e.detail.payload.newToken;
       sessionStorage.setItem(VONQ_SESSION_KEY, JSON.stringify(temp));
    });
}

_bindings();


